// firekultur-block-printing.js
// Blocks browser printing when the page is NotPrintablePage and logs sections with data-printable

// Log when the script loads
console.log('firekultur-block-printing.js: Script loaded');

// Initialize the Firekultur namespace if it doesn't exist
window.Firekultur = window.Firekultur || {};

// Set the shared isPagePrintable variable (default to true if not already set)
window.Firekultur.isPagePrintable = window.Firekultur.isPagePrintable !== undefined ? window.Firekultur.isPagePrintable : true;

// Function to scan all sections and log their details
function logPrintableSections() {
  // Target only top-level sections (e.g., direct children of shopify-section or with specific classes)
  const allSections = document.querySelectorAll('.shopify-section > [id], .shopify-section > section, .shopify-section > .section');
  console.log('firekultur-block-printing.js: Scanning all sections on the page...');

  if (allSections.length === 0) {
    console.log('firekultur-block-printing.js: No sections found on the page.');
    return;
  }

  // List all sections with a numbered index
  console.log('firekultur-block-printing.js: Listing all sections:');
  let sectionsWithoutDataPrintable = 0;

  allSections.forEach((section, index) => {
    const sectionId = section.id || section.className || 'unnamed-section';
    const hasDataPrintable = section.hasAttribute('data-printable');
    const dataPrintableValue = hasDataPrintable ? section.dataset.printable : 'not set';
    
    // Increment counter if data-printable is missing
    if (!hasDataPrintable) {
      sectionsWithoutDataPrintable++;
    }

    // Log the section details
    const tagName = section.tagName.toLowerCase();
    const parentClass = section.parentElement ? section.parentElement.className : 'no-parent';
    console.log(`firekultur-block-printing.js: ${index + 1}. Section ${sectionId} (tag: ${tagName}, parent: ${parentClass}, data-printable: ${dataPrintableValue})`);
  });

  // Log the count of sections without data-printable
  console.log(`firekultur-block-printing.js: Total sections scanned: ${allSections.length}`);
  console.log(`firekultur-block-printing.js: Sections without data-printable attribute: ${sectionsWithoutDataPrintable}`);

  // Universal selector for sections with data-printable
  const sectionsWithDataPrintable = document.querySelectorAll('[data-printable]');
  console.log('firekultur-block-printing.js: Scanning sections for data-printable attributes...');
  
  if (sectionsWithDataPrintable.length === 0) {
    console.log('firekultur-block-printing.js: No sections with data-printable attribute found.');
    return;
  }

  sectionsWithDataPrintable.forEach(section => {
    const sectionId = section.id || section.className || 'unnamed-section';
    const isSectionPrintable = section.dataset.printable !== 'false';

    const tagName = section.tagName.toLowerCase();
    const parentClass = section.parentElement ? section.parentElement.className : 'no-parent';
    console.log(`firekultur-block-printing.js: Section ${sectionId} (tag: ${tagName}, parent: ${parentClass}) is ${isSectionPrintable ? 'Printable' : 'Not Printable'} (data-printable="${section.dataset.printable}")`);
  });
}

// Function to initialize the script
function initializeBlockPrinting() {
  console.log('firekultur-block-printing.js: Script loaded and DOMContentLoaded event fired');
  logPrintableSections();

  // Listen for PagePrintability event from firekultur-page-classifier.js
  document.addEventListener('PagePrintability', (event) => {
    window.Firekultur.isPagePrintable = event.detail.printable;
    console.log(`firekultur-block-printing.js: Page printability set to: ${window.Firekultur.isPagePrintable}`);

    // Update the <body> tag with the printability status for CSS
    document.body.setAttribute('data-printable', window.Firekultur.isPagePrintable);

    // Log sections with data-printable attributes
    logPrintableSections();
  });

  // Intercept print attempts
  window.addEventListener('beforeprint', (event) => {
    if (!window.Firekultur.isPagePrintable) {
      console.log('firekultur-block-printing.js: Print attempt detected. Blocking print.');
      alert('Printing is disabled for this page.');
      window.stop();
    }
  });
}

// Run the script either on DOMContentLoaded or immediately if the event has already fired
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBlockPrinting);
} else {
  initializeBlockPrinting();
}